export default "__VITE_PUBLIC_ASSET__4e985964__"